import { render, staticRenderFns } from "./StockDetail.vue?vue&type=template&id=d862ca24&scoped=true&"
import script from "./StockDetail.vue?vue&type=script&lang=js&"
export * from "./StockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d862ca24",
  null
  
)

export default component.exports